//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data() {
    return {
      IsShow: false,
      ActionList: [
        // { name: '选项' },
        // { name: '选项' },
        // { name: '选项', subname: '描述信息' }
      ],
    };
  },
  props: ["dataConfig"],
  methods: {

    Show(){
      this.IsShow = true;
    },
    Hide(){
      this.IsShow = false;
    },

    setData(actionList){
      if(!actionList) return;
      if(this.ActionList.length > 0){
        this.ActionList.splice(0,this.ActionList.length);
      }
      actionList.forEach(m => {
        var actionItem = {
          name : m.Text,
          dataItem : m          
        }
        this.ActionList.push(actionItem);
      });
    },

    async onActionSelect(actionItem) {

      console.log("onActionSelect-actionItem",actionItem);
      this.IsShow = false;
      //this.$msg.succ(actionItem.name);
      var btnDataItem = actionItem.dataItem;
      if(!btnDataItem) return;

      var actionObj = this.$parent.$getActionObj();
      await this.$cmd.ExecuteCmd(btnDataItem,actionObj);
    },

    onActionCancel() {
      
      this.IsShow = false;

    },
    
  }
};
